import React from "react";
import { withStyles } from '@material-ui/styles';
import { Link, withRouter } from 'react-router-dom';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';

import withCurrentUser from '../../hocs/with_current_user.js';
import withShowToast from '../../hocs/with_show_toast.js';
import { compose } from 'redux';

import MybilioTextLogoBronze from "../../resources/logo/mybilio_text_logo_bronze.js";

import AdminRoutes from "../routes.js";
import WebRoutes from "../../web/routes.js";

import { TopBarHeight } from "../constants.js";

const styles = theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: "white",
    borderBottom: "1px solid #eeeeee"
  },
  topBar: {
    minHeight: "5px",
    height: TopBarHeight
  },
  headerLogo: {
    // height: "45px",
    // width: "45px"
  },
  homeLink: {
    color: "white",
    '&:hover': {
      color: "white",
    }
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
    color: "#C27100"
  }
});

class TopBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  onLogout = () => {
    const { signOut, history } = this.props;
    if(signOut) {
      signOut(() => {
        history.push(WebRoutes.xavin())
      });
    }
  }

  render() {
    const { classes } = this.props;
    return <AppBar className = { classes.root } >
      <Toolbar className = { classes.topBar } >
        <Link to = { AdminRoutes.index() }
              className = { classes.homeLink }>
          <MybilioTextLogoBronze className = { classes.headerLogo } />
        </Link>
        <div className = { classes.flexGrow } />
        <IconButton className = { classes.signOutButton }
                    color = { "inherit" }
                    onClick = { this.onLogout } >
          <InputIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  }
}

export default compose(withRouter, withShowToast, withCurrentUser, withStyles(styles))(TopBar)
